module.exports = __webpack_public_path__ + "img/Ser cliente 576px.c1c950e0.png";